import { SwipeableDrawer } from '@mui/material'
import { DrawerStyle } from './style'

interface CommentsDrawerProps {
  open: boolean
  onClose: () => void
  children: React.ReactNode
}

const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)

export const CommentsDrawer = ({ open, onClose, children }: CommentsDrawerProps) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableBackdropTransition={!iOS}
      disableSwipeToOpen={true}
      disableDiscovery={iOS}
      swipeAreaWidth={56}
      slotProps={{
        paper: {
          sx: DrawerStyle,
        },
      }}
    >
      {children}
    </SwipeableDrawer>
  )
}
